import { render, staticRenderFns } from "./shareCode.vue?vue&type=template&id=1ef70240&scoped=true&"
import script from "./shareCode.vue?vue&type=script&lang=js&"
export * from "./shareCode.vue?vue&type=script&lang=js&"
import style0 from "./shareCode.vue?vue&type=style&index=0&id=1ef70240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef70240",
  null
  
)

component.options.__file = "shareCode.vue"
export default component.exports